import { useAppStoreSelector } from '../../hooks/useAppStoreSelector'
import { selectConcordeEnabled } from '../../store/selectors/config'

import { ConcordeJourneyLauncherTabs } from './ConcordeJourneyLauncherTabs'
import { LegacyJourneyLauncherTabs } from './LegacyJourneyLauncherTabs'
import type { BaseJourneyLauncherTabsProps } from './types'

export const JourneyLauncherTabs = (props: BaseJourneyLauncherTabsProps) => {
  const concordeEnabled = useAppStoreSelector(selectConcordeEnabled)

  return concordeEnabled ? (
    <ConcordeJourneyLauncherTabs {...props} />
  ) : (
    <LegacyJourneyLauncherTabs {...props} />
  )
}
